import { useState } from 'react';
import { Common } from '@thecvlb/design-system';

import { selectOrchestrate } from 'store';

import VerifyYourIdentity from 'modals/VerifyYourIdentity';
import Card from 'widgets/identityVerification/Card';
import ErrorMessages from 'widgets/identityVerification/ErrorMessages';

import { useAppSelector } from 'hooks';
import useAnalytics from 'hooks/useAnalytics';
import { useGetValidationDocs } from 'hooks/useGetValidationDocs';

import Heading from '../../components/Heading';

//TODO refactor: combine with Intro.tsx
const IdentityVerification = ({ onContinue }: { onContinue: () => void }) => {
  const {
    user: { accessToken }
  } = useAppSelector(selectOrchestrate);

  const logEvent = useAnalytics();
  const {
    docs,
    isLoading,
    isUpdating,
    refetchDocuments,
    handleVerifyIdentity,
    handleDeleteDocument
  } = useGetValidationDocs();
  const [verifyYourIdentityType, setVerifyYourIdentityType] = useState<'SELFIE' | 'GV'>();

  const { government, personPhoto } = docs;
  const filesUploaded = government._id && personPhoto._id;
  const filesIdentified = government.identity && personPhoto.identity;
  const filesVerified = government.identity?.isVerified && personPhoto.identity?.isVerified;
  const mergedErrors = [
    ...(government.identity?.errors || []),
    ...(personPhoto.identity?.errors || [])
  ];

  const handleSubmit = () => {
    logEvent('verify_identity_continue_btn_click');

    if (!government._id || (government.identity && !government.identity.isVerified))
      return setVerifyYourIdentityType('GV');
    if (!personPhoto._id || (personPhoto.identity && !personPhoto.identity.isVerified))
      return setVerifyYourIdentityType('SELFIE');

    handleVerifyIdentity(government._id, personPhoto._id, (isVerified) => {
      if (isVerified) {
        onContinue();
      } else {
        refetchDocuments();
        sessionStorage.setItem('identity-verified', 'false');
      }
    });
  };

  const handleClickDoThisLater = () => {
    logEvent('verify_identity_later_btn_click');
    onContinue();
  };

  return (
    <div className="flex flex-col gap-6">
      <VerifyYourIdentity
        accessToken={accessToken}
        docs={{ government, personPhoto }}
        refetchDocuments={refetchDocuments}
        type={verifyYourIdentityType}
        verifyIdentity={() => government._id && handleVerifyIdentity(government._id)}
        onClose={() => setVerifyYourIdentityType(undefined)}
      />
      <Heading
        category="Plan"
        subtitle={
          <span className="text-mSm md:text-sm">
            To comply with regulations, we need to confirm your identity. We will never share this
            information.
          </span>
        }
        title="Verify your identity"
      />
      <div className="flex w-full gap-3 max-md:my-6">
        <Card
          docs={docs}
          isLoading={isLoading}
          type="GV"
          onClick={setVerifyYourIdentityType}
          onDelete={handleDeleteDocument}
        />
        <Card
          docs={docs}
          type="SELFIE"
          onClick={setVerifyYourIdentityType}
          onDelete={handleDeleteDocument}
        />
      </div>
      <ErrorMessages
        filesIdentified={!!filesIdentified}
        filesVerified={!!filesVerified}
        mergedErrors={mergedErrors}
        verifyIdentity={() => government._id && handleVerifyIdentity(government._id)}
      />
      <div className="mt-auto flex w-full flex-col items-center gap-4 md:mt-4 md:gap-2">
        <Common.Button
          color="blue"
          disabled={!filesUploaded}
          isLoading={isUpdating}
          fullWidthOnMobile
          onClick={handleSubmit}
        >
          {filesIdentified ? 'Try another photo' : 'Submit'}
        </Common.Button>
        <Common.Button disabled={isUpdating} fullWidthOnMobile onClick={handleClickDoThisLater}>
          {filesIdentified ? 'Continue anyway' : 'I’ll do this later'}
        </Common.Button>
      </div>
    </div>
  );
};

export default IdentityVerification;
